import { get, writable } from "svelte/store";
import { SvelteFacetValue } from "../filter/SvelteFacetValue";

export const selectedCategoryPathValues = writable<Set<SvelteFacetValue>>(new Set());

export function addCategoryPathToStore(value: SvelteFacetValue) {
  const current = get(selectedCategoryPathValues);
  const updated = new Set([...Array.from(current), value]);
  selectedCategoryPathValues.update(() => updated);
}

export function deleteCategoryPathFromStore(id: string) {
  const current = get(selectedCategoryPathValues);
  const updated = new Set([...Array.from(current).filter((value) => value.id !== id)]);
  selectedCategoryPathValues.update(() => updated);
}

export function emptyCategoryPathStore() {
  selectedCategoryPathValues.set(new Set());
}
